import { render, staticRenderFns } from "./chat-page.vue?vue&type=template&id=dec31ee0&scoped=true&"
import script from "./chat-page.vue?vue&type=script&lang=js&"
export * from "./chat-page.vue?vue&type=script&lang=js&"
import style0 from "./chat-page.vue?vue&type=style&index=0&id=dec31ee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec31ee0",
  null
  
)

export default component.exports